import { Button, DialogContent as MuiDialogContent } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

export const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "10px",
  overflowY: "visible",

  ".MuiAutocomplete-root, & > .MuiFormControl-root": {
    width: "45%",
  },
});

export const AddButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "plusButton",
})<{
  plusButton: boolean;
}>({}, ({ theme, plusButton }) => ({
  ...(plusButton && {
    minWidth: 45,
    padding: 0,
    fontSize: "1.5em",
    lineHeight: "1.5em",
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.contrastText,

    "&:hover": {
      borderColor: alpha(theme.palette.primary.contrastText, 0.6),
    },
  }),
}));
